module.exports = __webpack_public_path__ + "assets/img/SN.c0620967.png";